const D = ["abyss", "acid", "aqua", "autumn", "black", "bumblebee", "business", "caramellatte", "cmyk", "coffee", "corporate", "cupcake", "cyberpunk", "dark", "dim", "dracula", "emerald", "fantasy", "forest", "garden", "halloween", "lemonade", "light", "lofi", "luxury", "night", "nord", "pastel", "retro", "silk", "sunset", "synthwave", "valentine", "winter", "wireframe"], I = {
  light: {
    "--color-base-100": "oklch(100% 0 0)",
    "--color-base-200": "oklch(98% 0 0)",
    "--color-base-300": "oklch(95% 0 0)",
    "--color-base-content": "oklch(21% .006 285.885)",
    "--color-primary": "oklch(45% .24 277.023)",
    "--color-primary-content": "oklch(93% .034 272.788)",
    "--color-secondary": "oklch(65% .241 354.308)",
    "--color-secondary-content": "oklch(94% .028 342.258)",
    "--color-accent": "oklch(77% .152 181.912)",
    "--color-accent-content": "oklch(38% .063 188.416)",
    "--color-neutral": "oklch(14% .005 285.823)",
    "--color-neutral-content": "oklch(92% .004 286.32)",
    "--color-info": "oklch(74% .16 232.661)",
    "--color-info-content": "oklch(29% .066 243.157)",
    "--color-success": "oklch(76% .177 163.223)",
    "--color-success-content": "oklch(37% .077 168.94)",
    "--color-warning": "oklch(82% .189 84.429)",
    "--color-warning-content": "oklch(41% .112 45.904)",
    "--color-error": "oklch(71% .194 13.428)",
    "--color-error-content": "oklch(27% .105 12.094)",
    "--radius-selector": ".5rem",
    "--radius-field": ".25rem",
    "--radius-box": ".5rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "1",
    "--noise": "0"
  },
  dark: {
    "--color-base-100": "oklch(25.33% .016 252.42)",
    "--color-base-200": "oklch(23.26% .014 253.1)",
    "--color-base-300": "oklch(21.15% .012 254.09)",
    "--color-base-content": "oklch(97.807% .029 256.847)",
    "--color-primary": "oklch(58% .233 277.117)",
    "--color-primary-content": "oklch(96% .018 272.314)",
    "--color-secondary": "oklch(65% .241 354.308)",
    "--color-secondary-content": "oklch(94% .028 342.258)",
    "--color-accent": "oklch(77% .152 181.912)",
    "--color-accent-content": "oklch(38% .063 188.416)",
    "--color-neutral": "oklch(14% .005 285.823)",
    "--color-neutral-content": "oklch(92% .004 286.32)",
    "--color-info": "oklch(74% .16 232.661)",
    "--color-info-content": "oklch(29% .066 243.157)",
    "--color-success": "oklch(76% .177 163.223)",
    "--color-success-content": "oklch(37% .077 168.94)",
    "--color-warning": "oklch(82% .189 84.429)",
    "--color-warning-content": "oklch(41% .112 45.904)",
    "--color-error": "oklch(71% .194 13.428)",
    "--color-error-content": "oklch(27% .105 12.094)",
    "--radius-selector": ".5rem",
    "--radius-field": ".25rem",
    "--radius-box": ".5rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "1",
    "--noise": "0"
  },
  cupcake: {
    "--color-base-100": "oklch(97.788% .004 56.375)",
    "--color-base-200": "oklch(93.982% .007 61.449)",
    "--color-base-300": "oklch(91.586% .006 53.44)",
    "--color-base-content": "oklch(23.574% .066 313.189)",
    "--color-primary": "oklch(85% .138 181.071)",
    "--color-primary-content": "oklch(43% .078 188.216)",
    "--color-secondary": "oklch(89% .061 343.231)",
    "--color-secondary-content": "oklch(45% .187 3.815)",
    "--color-accent": "oklch(90% .076 70.697)",
    "--color-accent-content": "oklch(47% .157 37.304)",
    "--color-neutral": "oklch(27% .006 286.033)",
    "--color-neutral-content": "oklch(92% .004 286.32)",
    "--color-info": "oklch(68% .169 237.323)",
    "--color-info-content": "oklch(29% .066 243.157)",
    "--color-success": "oklch(69% .17 162.48)",
    "--color-success-content": "oklch(26% .051 172.552)",
    "--color-warning": "oklch(79% .184 86.047)",
    "--color-warning-content": "oklch(28% .066 53.813)",
    "--color-error": "oklch(64% .246 16.439)",
    "--color-error-content": "oklch(27% .105 12.094)",
    "--radius-selector": "1rem",
    "--radius-field": "2rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "2px",
    "--depth": "1",
    "--noise": "0"
  },
  bumblebee: {
    "--color-base-100": "oklch(100% 0 0)",
    "--color-base-200": "oklch(97% 0 0)",
    "--color-base-300": "oklch(92% 0 0)",
    "--color-base-content": "oklch(20% 0 0)",
    "--color-primary": "oklch(85% .199 91.936)",
    "--color-primary-content": "oklch(42% .095 57.708)",
    "--color-secondary": "oklch(75% .183 55.934)",
    "--color-secondary-content": "oklch(40% .123 38.172)",
    "--color-accent": "oklch(0% 0 0)",
    "--color-accent-content": "oklch(100% 0 0)",
    "--color-neutral": "oklch(37% .01 67.558)",
    "--color-neutral-content": "oklch(92% .003 48.717)",
    "--color-info": "oklch(74% .16 232.661)",
    "--color-info-content": "oklch(39% .09 240.876)",
    "--color-success": "oklch(76% .177 163.223)",
    "--color-success-content": "oklch(37% .077 168.94)",
    "--color-warning": "oklch(82% .189 84.429)",
    "--color-warning-content": "oklch(41% .112 45.904)",
    "--color-error": "oklch(70% .191 22.216)",
    "--color-error-content": "oklch(39% .141 25.723)",
    "--radius-selector": "1rem",
    "--radius-field": ".5rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "1",
    "--noise": "0"
  },
  emerald: {
    "--color-base-100": "oklch(100% 0 0)",
    "--color-base-200": "oklch(93% 0 0)",
    "--color-base-300": "oklch(86% 0 0)",
    "--color-base-content": "oklch(35.519% .032 262.988)",
    "--color-primary": "oklch(76.662% .135 153.45)",
    "--color-primary-content": "oklch(33.387% .04 162.24)",
    "--color-secondary": "oklch(61.302% .202 261.294)",
    "--color-secondary-content": "oklch(100% 0 0)",
    "--color-accent": "oklch(72.772% .149 33.2)",
    "--color-accent-content": "oklch(0% 0 0)",
    "--color-neutral": "oklch(35.519% .032 262.988)",
    "--color-neutral-content": "oklch(98.462% .001 247.838)",
    "--color-info": "oklch(72.06% .191 231.6)",
    "--color-info-content": "oklch(0% 0 0)",
    "--color-success": "oklch(64.8% .15 160)",
    "--color-success-content": "oklch(0% 0 0)",
    "--color-warning": "oklch(84.71% .199 83.87)",
    "--color-warning-content": "oklch(0% 0 0)",
    "--color-error": "oklch(71.76% .221 22.18)",
    "--color-error-content": "oklch(0% 0 0)",
    "--radius-selector": "1rem",
    "--radius-field": ".5rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "0",
    "--noise": "0"
  },
  corporate: {
    "--color-base-100": "oklch(100% 0 0)",
    "--color-base-200": "oklch(93% 0 0)",
    "--color-base-300": "oklch(86% 0 0)",
    "--color-base-content": "oklch(22.389% .031 278.072)",
    "--color-primary": "oklch(58% .158 241.966)",
    "--color-primary-content": "oklch(100% 0 0)",
    "--color-secondary": "oklch(55% .046 257.417)",
    "--color-secondary-content": "oklch(100% 0 0)",
    "--color-accent": "oklch(60% .118 184.704)",
    "--color-accent-content": "oklch(100% 0 0)",
    "--color-neutral": "oklch(0% 0 0)",
    "--color-neutral-content": "oklch(100% 0 0)",
    "--color-info": "oklch(60% .126 221.723)",
    "--color-info-content": "oklch(100% 0 0)",
    "--color-success": "oklch(62% .194 149.214)",
    "--color-success-content": "oklch(100% 0 0)",
    "--color-warning": "oklch(85% .199 91.936)",
    "--color-warning-content": "oklch(0% 0 0)",
    "--color-error": "oklch(70% .191 22.216)",
    "--color-error-content": "oklch(0% 0 0)",
    "--radius-selector": ".25rem",
    "--radius-field": ".25rem",
    "--radius-box": ".25rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "0",
    "--noise": "0"
  },
  synthwave: {
    "--color-base-100": "oklch(15% .09 281.288)",
    "--color-base-200": "oklch(20% .09 281.288)",
    "--color-base-300": "oklch(25% .09 281.288)",
    "--color-base-content": "oklch(78% .115 274.713)",
    "--color-primary": "oklch(71% .202 349.761)",
    "--color-primary-content": "oklch(28% .109 3.907)",
    "--color-secondary": "oklch(82% .111 230.318)",
    "--color-secondary-content": "oklch(29% .066 243.157)",
    "--color-accent": "oklch(75% .183 55.934)",
    "--color-accent-content": "oklch(26% .079 36.259)",
    "--color-neutral": "oklch(45% .24 277.023)",
    "--color-neutral-content": "oklch(87% .065 274.039)",
    "--color-info": "oklch(74% .16 232.661)",
    "--color-info-content": "oklch(29% .066 243.157)",
    "--color-success": "oklch(77% .152 181.912)",
    "--color-success-content": "oklch(27% .046 192.524)",
    "--color-warning": "oklch(90% .182 98.111)",
    "--color-warning-content": "oklch(42% .095 57.708)",
    "--color-error": "oklch(73.7% .121 32.639)",
    "--color-error-content": "oklch(23.501% .096 290.329)",
    "--radius-selector": "1rem",
    "--radius-field": ".5rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "0",
    "--noise": "0"
  },
  retro: {
    "--color-base-100": "oklch(91.637% .034 90.515)",
    "--color-base-200": "oklch(88.272% .049 91.774)",
    "--color-base-300": "oklch(84.133% .065 90.856)",
    "--color-base-content": "oklch(41% .112 45.904)",
    "--color-primary": "oklch(80% .114 19.571)",
    "--color-primary-content": "oklch(39% .141 25.723)",
    "--color-secondary": "oklch(92% .084 155.995)",
    "--color-secondary-content": "oklch(44% .119 151.328)",
    "--color-accent": "oklch(68% .162 75.834)",
    "--color-accent-content": "oklch(41% .112 45.904)",
    "--color-neutral": "oklch(44% .011 73.639)",
    "--color-neutral-content": "oklch(86% .005 56.366)",
    "--color-info": "oklch(58% .158 241.966)",
    "--color-info-content": "oklch(96% .059 95.617)",
    "--color-success": "oklch(51% .096 186.391)",
    "--color-success-content": "oklch(96% .059 95.617)",
    "--color-warning": "oklch(64% .222 41.116)",
    "--color-warning-content": "oklch(96% .059 95.617)",
    "--color-error": "oklch(70% .191 22.216)",
    "--color-error-content": "oklch(40% .123 38.172)",
    "--radius-selector": ".25rem",
    "--radius-field": ".25rem",
    "--radius-box": ".5rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "0",
    "--noise": "0"
  },
  cyberpunk: {
    "--color-base-100": "oklch(94.51% .179 104.32)",
    "--color-base-200": "oklch(91.51% .179 104.32)",
    "--color-base-300": "oklch(85.51% .179 104.32)",
    "--color-base-content": "oklch(0% 0 0)",
    "--color-primary": "oklch(74.22% .209 6.35)",
    "--color-primary-content": "oklch(14.844% .041 6.35)",
    "--color-secondary": "oklch(83.33% .184 204.72)",
    "--color-secondary-content": "oklch(16.666% .036 204.72)",
    "--color-accent": "oklch(71.86% .217 310.43)",
    "--color-accent-content": "oklch(14.372% .043 310.43)",
    "--color-neutral": "oklch(23.04% .065 269.31)",
    "--color-neutral-content": "oklch(94.51% .179 104.32)",
    "--color-info": "oklch(72.06% .191 231.6)",
    "--color-info-content": "oklch(0% 0 0)",
    "--color-success": "oklch(64.8% .15 160)",
    "--color-success-content": "oklch(0% 0 0)",
    "--color-warning": "oklch(84.71% .199 83.87)",
    "--color-warning-content": "oklch(0% 0 0)",
    "--color-error": "oklch(71.76% .221 22.18)",
    "--color-error-content": "oklch(0% 0 0)",
    "--radius-selector": "0rem",
    "--radius-field": "0rem",
    "--radius-box": "0rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "0",
    "--noise": "0"
  },
  valentine: {
    "--color-base-100": "oklch(97% .014 343.198)",
    "--color-base-200": "oklch(94% .028 342.258)",
    "--color-base-300": "oklch(89% .061 343.231)",
    "--color-base-content": "oklch(52% .223 3.958)",
    "--color-primary": "oklch(65% .241 354.308)",
    "--color-primary-content": "oklch(100% 0 0)",
    "--color-secondary": "oklch(62% .265 303.9)",
    "--color-secondary-content": "oklch(97% .014 308.299)",
    "--color-accent": "oklch(82% .111 230.318)",
    "--color-accent-content": "oklch(39% .09 240.876)",
    "--color-neutral": "oklch(40% .153 2.432)",
    "--color-neutral-content": "oklch(89% .061 343.231)",
    "--color-info": "oklch(86% .127 207.078)",
    "--color-info-content": "oklch(44% .11 240.79)",
    "--color-success": "oklch(84% .143 164.978)",
    "--color-success-content": "oklch(43% .095 166.913)",
    "--color-warning": "oklch(75% .183 55.934)",
    "--color-warning-content": "oklch(26% .079 36.259)",
    "--color-error": "oklch(63% .237 25.331)",
    "--color-error-content": "oklch(97% .013 17.38)",
    "--radius-selector": "1rem",
    "--radius-field": "2rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "0",
    "--noise": "0"
  },
  halloween: {
    "--color-base-100": "oklch(21% .006 56.043)",
    "--color-base-200": "oklch(14% .004 49.25)",
    "--color-base-300": "oklch(0% 0 0)",
    "--color-base-content": "oklch(84.955% 0 0)",
    "--color-primary": "oklch(77.48% .204 60.62)",
    "--color-primary-content": "oklch(19.693% .004 196.779)",
    "--color-secondary": "oklch(45.98% .248 305.03)",
    "--color-secondary-content": "oklch(89.196% .049 305.03)",
    "--color-accent": "oklch(64.8% .223 136.073)",
    "--color-accent-content": "oklch(0% 0 0)",
    "--color-neutral": "oklch(24.371% .046 65.681)",
    "--color-neutral-content": "oklch(84.874% .009 65.681)",
    "--color-info": "oklch(54.615% .215 262.88)",
    "--color-info-content": "oklch(90.923% .043 262.88)",
    "--color-success": "oklch(62.705% .169 149.213)",
    "--color-success-content": "oklch(12.541% .033 149.213)",
    "--color-warning": "oklch(66.584% .157 58.318)",
    "--color-warning-content": "oklch(13.316% .031 58.318)",
    "--color-error": "oklch(65.72% .199 27.33)",
    "--color-error-content": "oklch(13.144% .039 27.33)",
    "--radius-selector": "1rem",
    "--radius-field": ".5rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "1",
    "--noise": "0"
  },
  garden: {
    "--color-base-100": "oklch(92.951% .002 17.197)",
    "--color-base-200": "oklch(86.445% .002 17.197)",
    "--color-base-300": "oklch(79.938% .001 17.197)",
    "--color-base-content": "oklch(16.961% .001 17.32)",
    "--color-primary": "oklch(62.45% .278 3.836)",
    "--color-primary-content": "oklch(100% 0 0)",
    "--color-secondary": "oklch(48.495% .11 355.095)",
    "--color-secondary-content": "oklch(89.699% .022 355.095)",
    "--color-accent": "oklch(56.273% .054 154.39)",
    "--color-accent-content": "oklch(100% 0 0)",
    "--color-neutral": "oklch(24.155% .049 89.07)",
    "--color-neutral-content": "oklch(92.951% .002 17.197)",
    "--color-info": "oklch(72.06% .191 231.6)",
    "--color-info-content": "oklch(0% 0 0)",
    "--color-success": "oklch(64.8% .15 160)",
    "--color-success-content": "oklch(0% 0 0)",
    "--color-warning": "oklch(84.71% .199 83.87)",
    "--color-warning-content": "oklch(0% 0 0)",
    "--color-error": "oklch(71.76% .221 22.18)",
    "--color-error-content": "oklch(0% 0 0)",
    "--radius-selector": "1rem",
    "--radius-field": ".5rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "0",
    "--noise": "0"
  },
  forest: {
    "--color-base-100": "oklch(20.84% .008 17.911)",
    "--color-base-200": "oklch(18.522% .007 17.911)",
    "--color-base-300": "oklch(16.203% .007 17.911)",
    "--color-base-content": "oklch(83.768% .001 17.911)",
    "--color-primary": "oklch(68.628% .185 148.958)",
    "--color-primary-content": "oklch(0% 0 0)",
    "--color-secondary": "oklch(69.776% .135 168.327)",
    "--color-secondary-content": "oklch(13.955% .027 168.327)",
    "--color-accent": "oklch(70.628% .119 185.713)",
    "--color-accent-content": "oklch(14.125% .023 185.713)",
    "--color-neutral": "oklch(30.698% .039 171.364)",
    "--color-neutral-content": "oklch(86.139% .007 171.364)",
    "--color-info": "oklch(72.06% .191 231.6)",
    "--color-info-content": "oklch(0% 0 0)",
    "--color-success": "oklch(64.8% .15 160)",
    "--color-success-content": "oklch(0% 0 0)",
    "--color-warning": "oklch(84.71% .199 83.87)",
    "--color-warning-content": "oklch(0% 0 0)",
    "--color-error": "oklch(71.76% .221 22.18)",
    "--color-error-content": "oklch(0% 0 0)",
    "--radius-selector": "1rem",
    "--radius-field": "2rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "0",
    "--noise": "0"
  },
  aqua: {
    "--color-base-100": "oklch(37% .146 265.522)",
    "--color-base-200": "oklch(28% .091 267.935)",
    "--color-base-300": "oklch(22% .091 267.935)",
    "--color-base-content": "oklch(90% .058 230.902)",
    "--color-primary": "oklch(85.661% .144 198.645)",
    "--color-primary-content": "oklch(40.124% .068 197.603)",
    "--color-secondary": "oklch(60.682% .108 309.782)",
    "--color-secondary-content": "oklch(96% .016 293.756)",
    "--color-accent": "oklch(93.426% .102 94.555)",
    "--color-accent-content": "oklch(18.685% .02 94.555)",
    "--color-neutral": "oklch(27% .146 265.522)",
    "--color-neutral-content": "oklch(80% .146 265.522)",
    "--color-info": "oklch(54.615% .215 262.88)",
    "--color-info-content": "oklch(90.923% .043 262.88)",
    "--color-success": "oklch(62.705% .169 149.213)",
    "--color-success-content": "oklch(12.541% .033 149.213)",
    "--color-warning": "oklch(66.584% .157 58.318)",
    "--color-warning-content": "oklch(27% .077 45.635)",
    "--color-error": "oklch(73.95% .19 27.33)",
    "--color-error-content": "oklch(14.79% .038 27.33)",
    "--radius-selector": "1rem",
    "--radius-field": ".5rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "1",
    "--noise": "0"
  },
  lofi: {
    "--color-base-100": "oklch(100% 0 0)",
    "--color-base-200": "oklch(97% 0 0)",
    "--color-base-300": "oklch(94% 0 0)",
    "--color-base-content": "oklch(0% 0 0)",
    "--color-primary": "oklch(15.906% 0 0)",
    "--color-primary-content": "oklch(100% 0 0)",
    "--color-secondary": "oklch(21.455% .001 17.278)",
    "--color-secondary-content": "oklch(100% 0 0)",
    "--color-accent": "oklch(26.861% 0 0)",
    "--color-accent-content": "oklch(100% 0 0)",
    "--color-neutral": "oklch(0% 0 0)",
    "--color-neutral-content": "oklch(100% 0 0)",
    "--color-info": "oklch(79.54% .103 205.9)",
    "--color-info-content": "oklch(15.908% .02 205.9)",
    "--color-success": "oklch(90.13% .153 164.14)",
    "--color-success-content": "oklch(18.026% .03 164.14)",
    "--color-warning": "oklch(88.37% .135 79.94)",
    "--color-warning-content": "oklch(17.674% .027 79.94)",
    "--color-error": "oklch(78.66% .15 28.47)",
    "--color-error-content": "oklch(15.732% .03 28.47)",
    "--radius-selector": "2rem",
    "--radius-field": ".25rem",
    "--radius-box": ".5rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "0",
    "--noise": "0"
  },
  pastel: {
    "--color-base-100": "oklch(100% 0 0)",
    "--color-base-200": "oklch(98.462% .001 247.838)",
    "--color-base-300": "oklch(92.462% .001 247.838)",
    "--color-base-content": "oklch(20% 0 0)",
    "--color-primary": "oklch(90% .063 306.703)",
    "--color-primary-content": "oklch(49% .265 301.924)",
    "--color-secondary": "oklch(89% .058 10.001)",
    "--color-secondary-content": "oklch(51% .222 16.935)",
    "--color-accent": "oklch(90% .093 164.15)",
    "--color-accent-content": "oklch(50% .118 165.612)",
    "--color-neutral": "oklch(55% .046 257.417)",
    "--color-neutral-content": "oklch(92% .013 255.508)",
    "--color-info": "oklch(86% .127 207.078)",
    "--color-info-content": "oklch(52% .105 223.128)",
    "--color-success": "oklch(87% .15 154.449)",
    "--color-success-content": "oklch(52% .154 150.069)",
    "--color-warning": "oklch(83% .128 66.29)",
    "--color-warning-content": "oklch(55% .195 38.402)",
    "--color-error": "oklch(80% .114 19.571)",
    "--color-error-content": "oklch(50% .213 27.518)",
    "--radius-selector": "1rem",
    "--radius-field": "2rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "2px",
    "--depth": "0",
    "--noise": "0"
  },
  fantasy: {
    "--color-base-100": "oklch(100% 0 0)",
    "--color-base-200": "oklch(93% 0 0)",
    "--color-base-300": "oklch(86% 0 0)",
    "--color-base-content": "oklch(27.807% .029 256.847)",
    "--color-primary": "oklch(37.45% .189 325.02)",
    "--color-primary-content": "oklch(87.49% .037 325.02)",
    "--color-secondary": "oklch(53.92% .162 241.36)",
    "--color-secondary-content": "oklch(90.784% .032 241.36)",
    "--color-accent": "oklch(75.98% .204 56.72)",
    "--color-accent-content": "oklch(15.196% .04 56.72)",
    "--color-neutral": "oklch(27.807% .029 256.847)",
    "--color-neutral-content": "oklch(85.561% .005 256.847)",
    "--color-info": "oklch(72.06% .191 231.6)",
    "--color-info-content": "oklch(0% 0 0)",
    "--color-success": "oklch(64.8% .15 160)",
    "--color-success-content": "oklch(0% 0 0)",
    "--color-warning": "oklch(84.71% .199 83.87)",
    "--color-warning-content": "oklch(0% 0 0)",
    "--color-error": "oklch(71.76% .221 22.18)",
    "--color-error-content": "oklch(0% 0 0)",
    "--radius-selector": "1rem",
    "--radius-field": ".5rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "1",
    "--noise": "0"
  },
  wireframe: {
    "--color-base-100": "oklch(100% 0 0)",
    "--color-base-200": "oklch(97% 0 0)",
    "--color-base-300": "oklch(94% 0 0)",
    "--color-base-content": "oklch(20% 0 0)",
    "--color-primary": "oklch(87% 0 0)",
    "--color-primary-content": "oklch(26% 0 0)",
    "--color-secondary": "oklch(87% 0 0)",
    "--color-secondary-content": "oklch(26% 0 0)",
    "--color-accent": "oklch(87% 0 0)",
    "--color-accent-content": "oklch(26% 0 0)",
    "--color-neutral": "oklch(87% 0 0)",
    "--color-neutral-content": "oklch(26% 0 0)",
    "--color-info": "oklch(44% .11 240.79)",
    "--color-info-content": "oklch(90% .058 230.902)",
    "--color-success": "oklch(43% .095 166.913)",
    "--color-success-content": "oklch(90% .093 164.15)",
    "--color-warning": "oklch(47% .137 46.201)",
    "--color-warning-content": "oklch(92% .12 95.746)",
    "--color-error": "oklch(44% .177 26.899)",
    "--color-error-content": "oklch(88% .062 18.334)",
    "--radius-selector": "0rem",
    "--radius-field": ".25rem",
    "--radius-box": ".25rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "0",
    "--noise": "0"
  },
  black: {
    "--color-base-100": "oklch(0% 0 0)",
    "--color-base-200": "oklch(19% 0 0)",
    "--color-base-300": "oklch(22% 0 0)",
    "--color-base-content": "oklch(87.609% 0 0)",
    "--color-primary": "oklch(35% 0 0)",
    "--color-primary-content": "oklch(100% 0 0)",
    "--color-secondary": "oklch(35% 0 0)",
    "--color-secondary-content": "oklch(100% 0 0)",
    "--color-accent": "oklch(35% 0 0)",
    "--color-accent-content": "oklch(100% 0 0)",
    "--color-neutral": "oklch(35% 0 0)",
    "--color-neutral-content": "oklch(100% 0 0)",
    "--color-info": "oklch(45.201% .313 264.052)",
    "--color-info-content": "oklch(89.04% .062 264.052)",
    "--color-success": "oklch(51.975% .176 142.495)",
    "--color-success-content": "oklch(90.395% .035 142.495)",
    "--color-warning": "oklch(96.798% .211 109.769)",
    "--color-warning-content": "oklch(19.359% .042 109.769)",
    "--color-error": "oklch(62.795% .257 29.233)",
    "--color-error-content": "oklch(12.559% .051 29.233)",
    "--radius-selector": "0rem",
    "--radius-field": "0rem",
    "--radius-box": "0rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "0",
    "--noise": "0"
  },
  luxury: {
    "--color-base-100": "oklch(14.076% .004 285.822)",
    "--color-base-200": "oklch(20.219% .004 308.229)",
    "--color-base-300": "oklch(23.219% .004 308.229)",
    "--color-base-content": "oklch(75.687% .123 76.89)",
    "--color-primary": "oklch(100% 0 0)",
    "--color-primary-content": "oklch(20% 0 0)",
    "--color-secondary": "oklch(27.581% .064 261.069)",
    "--color-secondary-content": "oklch(85.516% .012 261.069)",
    "--color-accent": "oklch(36.674% .051 338.825)",
    "--color-accent-content": "oklch(87.334% .01 338.825)",
    "--color-neutral": "oklch(24.27% .057 59.825)",
    "--color-neutral-content": "oklch(93.203% .089 90.861)",
    "--color-info": "oklch(79.061% .121 237.133)",
    "--color-info-content": "oklch(15.812% .024 237.133)",
    "--color-success": "oklch(78.119% .192 132.154)",
    "--color-success-content": "oklch(15.623% .038 132.154)",
    "--color-warning": "oklch(86.127% .136 102.891)",
    "--color-warning-content": "oklch(17.225% .027 102.891)",
    "--color-error": "oklch(71.753% .176 22.568)",
    "--color-error-content": "oklch(14.35% .035 22.568)",
    "--radius-selector": "1rem",
    "--radius-field": ".5rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "1",
    "--noise": "0"
  },
  dracula: {
    "--color-base-100": "oklch(28.822% .022 277.508)",
    "--color-base-200": "oklch(26.805% .02 277.508)",
    "--color-base-300": "oklch(24.787% .019 277.508)",
    "--color-base-content": "oklch(97.747% .007 106.545)",
    "--color-primary": "oklch(75.461% .183 346.812)",
    "--color-primary-content": "oklch(15.092% .036 346.812)",
    "--color-secondary": "oklch(74.202% .148 301.883)",
    "--color-secondary-content": "oklch(14.84% .029 301.883)",
    "--color-accent": "oklch(83.392% .124 66.558)",
    "--color-accent-content": "oklch(16.678% .024 66.558)",
    "--color-neutral": "oklch(39.445% .032 275.524)",
    "--color-neutral-content": "oklch(87.889% .006 275.524)",
    "--color-info": "oklch(88.263% .093 212.846)",
    "--color-info-content": "oklch(17.652% .018 212.846)",
    "--color-success": "oklch(87.099% .219 148.024)",
    "--color-success-content": "oklch(17.419% .043 148.024)",
    "--color-warning": "oklch(95.533% .134 112.757)",
    "--color-warning-content": "oklch(19.106% .026 112.757)",
    "--color-error": "oklch(68.22% .206 24.43)",
    "--color-error-content": "oklch(13.644% .041 24.43)",
    "--radius-selector": "1rem",
    "--radius-field": ".5rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "0",
    "--noise": "0"
  },
  cmyk: {
    "--color-base-100": "oklch(100% 0 0)",
    "--color-base-200": "oklch(95% 0 0)",
    "--color-base-300": "oklch(90% 0 0)",
    "--color-base-content": "oklch(20% 0 0)",
    "--color-primary": "oklch(71.772% .133 239.443)",
    "--color-primary-content": "oklch(14.354% .026 239.443)",
    "--color-secondary": "oklch(64.476% .202 359.339)",
    "--color-secondary-content": "oklch(12.895% .04 359.339)",
    "--color-accent": "oklch(94.228% .189 105.306)",
    "--color-accent-content": "oklch(18.845% .037 105.306)",
    "--color-neutral": "oklch(21.778% 0 0)",
    "--color-neutral-content": "oklch(84.355% 0 0)",
    "--color-info": "oklch(68.475% .094 217.284)",
    "--color-info-content": "oklch(13.695% .018 217.284)",
    "--color-success": "oklch(46.949% .162 321.406)",
    "--color-success-content": "oklch(89.389% .032 321.406)",
    "--color-warning": "oklch(71.236% .159 52.023)",
    "--color-warning-content": "oklch(14.247% .031 52.023)",
    "--color-error": "oklch(62.013% .208 28.717)",
    "--color-error-content": "oklch(12.402% .041 28.717)",
    "--radius-selector": "1rem",
    "--radius-field": ".5rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "0",
    "--noise": "0"
  },
  autumn: {
    "--color-base-100": "oklch(95.814% 0 0)",
    "--color-base-200": "oklch(89.107% 0 0)",
    "--color-base-300": "oklch(82.4% 0 0)",
    "--color-base-content": "oklch(19.162% 0 0)",
    "--color-primary": "oklch(40.723% .161 17.53)",
    "--color-primary-content": "oklch(88.144% .032 17.53)",
    "--color-secondary": "oklch(61.676% .169 23.865)",
    "--color-secondary-content": "oklch(12.335% .033 23.865)",
    "--color-accent": "oklch(73.425% .094 60.729)",
    "--color-accent-content": "oklch(14.685% .018 60.729)",
    "--color-neutral": "oklch(54.367% .037 51.902)",
    "--color-neutral-content": "oklch(90.873% .007 51.902)",
    "--color-info": "oklch(69.224% .097 207.284)",
    "--color-info-content": "oklch(13.844% .019 207.284)",
    "--color-success": "oklch(60.995% .08 174.616)",
    "--color-success-content": "oklch(12.199% .016 174.616)",
    "--color-warning": "oklch(70.081% .164 56.844)",
    "--color-warning-content": "oklch(14.016% .032 56.844)",
    "--color-error": "oklch(53.07% .241 24.16)",
    "--color-error-content": "oklch(90.614% .048 24.16)",
    "--radius-selector": "1rem",
    "--radius-field": ".5rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "1",
    "--noise": "0"
  },
  business: {
    "--color-base-100": "oklch(24.353% 0 0)",
    "--color-base-200": "oklch(22.648% 0 0)",
    "--color-base-300": "oklch(20.944% 0 0)",
    "--color-base-content": "oklch(84.87% 0 0)",
    "--color-primary": "oklch(41.703% .099 251.473)",
    "--color-primary-content": "oklch(88.34% .019 251.473)",
    "--color-secondary": "oklch(64.092% .027 229.389)",
    "--color-secondary-content": "oklch(12.818% .005 229.389)",
    "--color-accent": "oklch(67.271% .167 35.791)",
    "--color-accent-content": "oklch(13.454% .033 35.791)",
    "--color-neutral": "oklch(27.441% .013 253.041)",
    "--color-neutral-content": "oklch(85.488% .002 253.041)",
    "--color-info": "oklch(62.616% .143 240.033)",
    "--color-info-content": "oklch(12.523% .028 240.033)",
    "--color-success": "oklch(70.226% .094 156.596)",
    "--color-success-content": "oklch(14.045% .018 156.596)",
    "--color-warning": "oklch(77.482% .115 81.519)",
    "--color-warning-content": "oklch(15.496% .023 81.519)",
    "--color-error": "oklch(51.61% .146 29.674)",
    "--color-error-content": "oklch(90.322% .029 29.674)",
    "--radius-selector": "0rem",
    "--radius-field": ".25rem",
    "--radius-box": ".25rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "0",
    "--noise": "0"
  },
  acid: {
    "--color-base-100": "oklch(98% 0 0)",
    "--color-base-200": "oklch(95% 0 0)",
    "--color-base-300": "oklch(91% 0 0)",
    "--color-base-content": "oklch(0% 0 0)",
    "--color-primary": "oklch(71.9% .357 330.759)",
    "--color-primary-content": "oklch(14.38% .071 330.759)",
    "--color-secondary": "oklch(73.37% .224 48.25)",
    "--color-secondary-content": "oklch(14.674% .044 48.25)",
    "--color-accent": "oklch(92.78% .264 122.962)",
    "--color-accent-content": "oklch(18.556% .052 122.962)",
    "--color-neutral": "oklch(21.31% .128 278.68)",
    "--color-neutral-content": "oklch(84.262% .025 278.68)",
    "--color-info": "oklch(60.72% .227 252.05)",
    "--color-info-content": "oklch(12.144% .045 252.05)",
    "--color-success": "oklch(85.72% .266 158.53)",
    "--color-success-content": "oklch(17.144% .053 158.53)",
    "--color-warning": "oklch(91.01% .212 100.5)",
    "--color-warning-content": "oklch(18.202% .042 100.5)",
    "--color-error": "oklch(64.84% .293 29.349)",
    "--color-error-content": "oklch(12.968% .058 29.349)",
    "--radius-selector": "1rem",
    "--radius-field": "1rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "1",
    "--noise": "0"
  },
  lemonade: {
    "--color-base-100": "oklch(98.71% .02 123.72)",
    "--color-base-200": "oklch(91.8% .018 123.72)",
    "--color-base-300": "oklch(84.89% .017 123.72)",
    "--color-base-content": "oklch(19.742% .004 123.72)",
    "--color-primary": "oklch(58.92% .199 134.6)",
    "--color-primary-content": "oklch(11.784% .039 134.6)",
    "--color-secondary": "oklch(77.75% .196 111.09)",
    "--color-secondary-content": "oklch(15.55% .039 111.09)",
    "--color-accent": "oklch(85.39% .201 100.73)",
    "--color-accent-content": "oklch(17.078% .04 100.73)",
    "--color-neutral": "oklch(30.98% .075 108.6)",
    "--color-neutral-content": "oklch(86.196% .015 108.6)",
    "--color-info": "oklch(86.19% .047 224.14)",
    "--color-info-content": "oklch(17.238% .009 224.14)",
    "--color-success": "oklch(86.19% .047 157.85)",
    "--color-success-content": "oklch(17.238% .009 157.85)",
    "--color-warning": "oklch(86.19% .047 102.15)",
    "--color-warning-content": "oklch(17.238% .009 102.15)",
    "--color-error": "oklch(86.19% .047 25.85)",
    "--color-error-content": "oklch(17.238% .009 25.85)",
    "--radius-selector": "1rem",
    "--radius-field": ".5rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "0",
    "--noise": "0"
  },
  night: {
    "--color-base-100": "oklch(20.768% .039 265.754)",
    "--color-base-200": "oklch(19.314% .037 265.754)",
    "--color-base-300": "oklch(17.86% .034 265.754)",
    "--color-base-content": "oklch(84.153% .007 265.754)",
    "--color-primary": "oklch(75.351% .138 232.661)",
    "--color-primary-content": "oklch(15.07% .027 232.661)",
    "--color-secondary": "oklch(68.011% .158 276.934)",
    "--color-secondary-content": "oklch(13.602% .031 276.934)",
    "--color-accent": "oklch(72.36% .176 350.048)",
    "--color-accent-content": "oklch(14.472% .035 350.048)",
    "--color-neutral": "oklch(27.949% .036 260.03)",
    "--color-neutral-content": "oklch(85.589% .007 260.03)",
    "--color-info": "oklch(68.455% .148 237.251)",
    "--color-info-content": "oklch(0% 0 0)",
    "--color-success": "oklch(78.452% .132 181.911)",
    "--color-success-content": "oklch(15.69% .026 181.911)",
    "--color-warning": "oklch(83.242% .139 82.95)",
    "--color-warning-content": "oklch(16.648% .027 82.95)",
    "--color-error": "oklch(71.785% .17 13.118)",
    "--color-error-content": "oklch(14.357% .034 13.118)",
    "--radius-selector": "1rem",
    "--radius-field": ".5rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "0",
    "--noise": "0"
  },
  coffee: {
    "--color-base-100": "oklch(24% .023 329.708)",
    "--color-base-200": "oklch(21% .021 329.708)",
    "--color-base-300": "oklch(16% .019 329.708)",
    "--color-base-content": "oklch(72.354% .092 79.129)",
    "--color-primary": "oklch(71.996% .123 62.756)",
    "--color-primary-content": "oklch(14.399% .024 62.756)",
    "--color-secondary": "oklch(34.465% .029 199.194)",
    "--color-secondary-content": "oklch(86.893% .005 199.194)",
    "--color-accent": "oklch(42.621% .074 224.389)",
    "--color-accent-content": "oklch(88.524% .014 224.389)",
    "--color-neutral": "oklch(16.51% .015 326.261)",
    "--color-neutral-content": "oklch(83.302% .003 326.261)",
    "--color-info": "oklch(79.49% .063 184.558)",
    "--color-info-content": "oklch(15.898% .012 184.558)",
    "--color-success": "oklch(74.722% .072 131.116)",
    "--color-success-content": "oklch(14.944% .014 131.116)",
    "--color-warning": "oklch(88.15% .14 87.722)",
    "--color-warning-content": "oklch(17.63% .028 87.722)",
    "--color-error": "oklch(77.318% .128 31.871)",
    "--color-error-content": "oklch(15.463% .025 31.871)",
    "--radius-selector": "1rem",
    "--radius-field": ".5rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "0",
    "--noise": "0"
  },
  winter: {
    "--color-base-100": "oklch(100% 0 0)",
    "--color-base-200": "oklch(97.466% .011 259.822)",
    "--color-base-300": "oklch(93.268% .016 262.751)",
    "--color-base-content": "oklch(41.886% .053 255.824)",
    "--color-primary": "oklch(56.86% .255 257.57)",
    "--color-primary-content": "oklch(91.372% .051 257.57)",
    "--color-secondary": "oklch(42.551% .161 282.339)",
    "--color-secondary-content": "oklch(88.51% .032 282.339)",
    "--color-accent": "oklch(59.939% .191 335.171)",
    "--color-accent-content": "oklch(11.988% .038 335.171)",
    "--color-neutral": "oklch(19.616% .063 257.651)",
    "--color-neutral-content": "oklch(83.923% .012 257.651)",
    "--color-info": "oklch(88.127% .085 214.515)",
    "--color-info-content": "oklch(17.625% .017 214.515)",
    "--color-success": "oklch(80.494% .077 197.823)",
    "--color-success-content": "oklch(16.098% .015 197.823)",
    "--color-warning": "oklch(89.172% .045 71.47)",
    "--color-warning-content": "oklch(17.834% .009 71.47)",
    "--color-error": "oklch(73.092% .11 20.076)",
    "--color-error-content": "oklch(14.618% .022 20.076)",
    "--radius-selector": "1rem",
    "--radius-field": ".5rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "0",
    "--noise": "0"
  },
  dim: {
    "--color-base-100": "oklch(30.857% .023 264.149)",
    "--color-base-200": "oklch(28.036% .019 264.182)",
    "--color-base-300": "oklch(26.346% .018 262.177)",
    "--color-base-content": "oklch(82.901% .031 222.959)",
    "--color-primary": "oklch(86.133% .141 139.549)",
    "--color-primary-content": "oklch(17.226% .028 139.549)",
    "--color-secondary": "oklch(73.375% .165 35.353)",
    "--color-secondary-content": "oklch(14.675% .033 35.353)",
    "--color-accent": "oklch(74.229% .133 311.379)",
    "--color-accent-content": "oklch(14.845% .026 311.379)",
    "--color-neutral": "oklch(24.731% .02 264.094)",
    "--color-neutral-content": "oklch(82.901% .031 222.959)",
    "--color-info": "oklch(86.078% .142 206.182)",
    "--color-info-content": "oklch(17.215% .028 206.182)",
    "--color-success": "oklch(86.171% .142 166.534)",
    "--color-success-content": "oklch(17.234% .028 166.534)",
    "--color-warning": "oklch(86.163% .142 94.818)",
    "--color-warning-content": "oklch(17.232% .028 94.818)",
    "--color-error": "oklch(82.418% .099 33.756)",
    "--color-error-content": "oklch(16.483% .019 33.756)",
    "--radius-selector": "1rem",
    "--radius-field": ".5rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "0",
    "--noise": "0"
  },
  nord: {
    "--color-base-100": "oklch(95.127% .007 260.731)",
    "--color-base-200": "oklch(93.299% .01 261.788)",
    "--color-base-300": "oklch(89.925% .016 262.749)",
    "--color-base-content": "oklch(32.437% .022 264.182)",
    "--color-primary": "oklch(59.435% .077 254.027)",
    "--color-primary-content": "oklch(11.887% .015 254.027)",
    "--color-secondary": "oklch(69.651% .059 248.687)",
    "--color-secondary-content": "oklch(13.93% .011 248.687)",
    "--color-accent": "oklch(77.464% .062 217.469)",
    "--color-accent-content": "oklch(15.492% .012 217.469)",
    "--color-neutral": "oklch(45.229% .035 264.131)",
    "--color-neutral-content": "oklch(89.925% .016 262.749)",
    "--color-info": "oklch(69.207% .062 332.664)",
    "--color-info-content": "oklch(13.841% .012 332.664)",
    "--color-success": "oklch(76.827% .074 131.063)",
    "--color-success-content": "oklch(15.365% .014 131.063)",
    "--color-warning": "oklch(85.486% .089 84.093)",
    "--color-warning-content": "oklch(17.097% .017 84.093)",
    "--color-error": "oklch(60.61% .12 15.341)",
    "--color-error-content": "oklch(12.122% .024 15.341)",
    "--radius-selector": "1rem",
    "--radius-field": ".25rem",
    "--radius-box": ".5rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "0",
    "--noise": "0"
  },
  sunset: {
    "--color-base-100": "oklch(22% .019 237.69)",
    "--color-base-200": "oklch(20% .019 237.69)",
    "--color-base-300": "oklch(18% .019 237.69)",
    "--color-base-content": "oklch(77.383% .043 245.096)",
    "--color-primary": "oklch(74.703% .158 39.947)",
    "--color-primary-content": "oklch(14.94% .031 39.947)",
    "--color-secondary": "oklch(72.537% .177 2.72)",
    "--color-secondary-content": "oklch(14.507% .035 2.72)",
    "--color-accent": "oklch(71.294% .166 299.844)",
    "--color-accent-content": "oklch(14.258% .033 299.844)",
    "--color-neutral": "oklch(26% .019 237.69)",
    "--color-neutral-content": "oklch(70% .019 237.69)",
    "--color-info": "oklch(85.559% .085 206.015)",
    "--color-info-content": "oklch(17.111% .017 206.015)",
    "--color-success": "oklch(85.56% .085 144.778)",
    "--color-success-content": "oklch(17.112% .017 144.778)",
    "--color-warning": "oklch(85.569% .084 74.427)",
    "--color-warning-content": "oklch(17.113% .016 74.427)",
    "--color-error": "oklch(85.511% .078 16.886)",
    "--color-error-content": "oklch(17.102% .015 16.886)",
    "--radius-selector": "1rem",
    "--radius-field": ".5rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "0",
    "--noise": "0"
  },
  caramellatte: {
    "--color-base-100": "oklch(98% .016 73.684)",
    "--color-base-200": "oklch(95% .038 75.164)",
    "--color-base-300": "oklch(90% .076 70.697)",
    "--color-base-content": "oklch(40% .123 38.172)",
    "--color-primary": "oklch(0% 0 0)",
    "--color-primary-content": "oklch(100% 0 0)",
    "--color-secondary": "oklch(22.45% .075 37.85)",
    "--color-secondary-content": "oklch(90% .076 70.697)",
    "--color-accent": "oklch(46.44% .111 37.85)",
    "--color-accent-content": "oklch(90% .076 70.697)",
    "--color-neutral": "oklch(55% .195 38.402)",
    "--color-neutral-content": "oklch(98% .016 73.684)",
    "--color-info": "oklch(42% .199 265.638)",
    "--color-info-content": "oklch(90% .076 70.697)",
    "--color-success": "oklch(43% .095 166.913)",
    "--color-success-content": "oklch(90% .076 70.697)",
    "--color-warning": "oklch(82% .189 84.429)",
    "--color-warning-content": "oklch(41% .112 45.904)",
    "--color-error": "oklch(70% .191 22.216)",
    "--color-error-content": "oklch(39% .141 25.723)",
    "--radius-selector": "2rem",
    "--radius-field": ".5rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "2px",
    "--depth": "1",
    "--noise": "1"
  },
  abyss: {
    "--color-base-100": "oklch(20% .08 209)",
    "--color-base-200": "oklch(15% .08 209)",
    "--color-base-300": "oklch(10% .08 209)",
    "--color-base-content": "oklch(90% .076 70.697)",
    "--color-primary": "oklch(92% .2653 125)",
    "--color-primary-content": "oklch(50% .2653 125)",
    "--color-secondary": "oklch(83.27% .0764 298.3)",
    "--color-secondary-content": "oklch(43.27% .0764 298.3)",
    "--color-accent": "oklch(43% 0 0)",
    "--color-accent-content": "oklch(98% 0 0)",
    "--color-neutral": "oklch(30% .08 209)",
    "--color-neutral-content": "oklch(90% .076 70.697)",
    "--color-info": "oklch(74% .16 232.661)",
    "--color-info-content": "oklch(29% .066 243.157)",
    "--color-success": "oklch(79% .209 151.711)",
    "--color-success-content": "oklch(26% .065 152.934)",
    "--color-warning": "oklch(84.8% .1962 84.62)",
    "--color-warning-content": "oklch(44.8% .1962 84.62)",
    "--color-error": "oklch(65% .1985 24.22)",
    "--color-error-content": "oklch(27% .1985 24.22)",
    "--radius-selector": "2rem",
    "--radius-field": ".25rem",
    "--radius-box": ".5rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "1px",
    "--depth": "1",
    "--noise": "0"
  },
  silk: {
    "--color-base-100": "oklch(97% .0035 67.78)",
    "--color-base-200": "oklch(95% .0081 61.42)",
    "--color-base-300": "oklch(90% .0081 61.42)",
    "--color-base-content": "oklch(40% .0081 61.42)",
    "--color-primary": "oklch(23.27% .0249 284.3)",
    "--color-primary-content": "oklch(94.22% .2505 117.44)",
    "--color-secondary": "oklch(23.27% .0249 284.3)",
    "--color-secondary-content": "oklch(73.92% .2135 50.94)",
    "--color-accent": "oklch(23.27% .0249 284.3)",
    "--color-accent-content": "oklch(88.92% .2061 189.9)",
    "--color-neutral": "oklch(20% 0 0)",
    "--color-neutral-content": "oklch(80% .0081 61.42)",
    "--color-info": "oklch(80.39% .1148 241.68)",
    "--color-info-content": "oklch(30.39% .1148 241.68)",
    "--color-success": "oklch(83.92% .0901 136.87)",
    "--color-success-content": "oklch(23.92% .0901 136.87)",
    "--color-warning": "oklch(83.92% .1085 80)",
    "--color-warning-content": "oklch(43.92% .1085 80)",
    "--color-error": "oklch(75.1% .1814 22.37)",
    "--color-error-content": "oklch(35.1% .1814 22.37)",
    "--radius-selector": "2rem",
    "--radius-field": ".5rem",
    "--radius-box": "1rem",
    "--size-selector": ".25rem",
    "--size-field": ".25rem",
    "--border": "2px",
    "--depth": "1",
    "--noise": "0"
  }
}, M = {
  light: "light",
  dark: "dark",
  cupcake: "light",
  bumblebee: "light",
  emerald: "light",
  corporate: "light",
  synthwave: "dark",
  retro: "light",
  cyberpunk: "light",
  valentine: "light",
  halloween: "dark",
  garden: "light",
  forest: "dark",
  aqua: "dark",
  lofi: "light",
  pastel: "light",
  fantasy: "light",
  wireframe: "light",
  black: "dark",
  luxury: "dark",
  dracula: "dark",
  cmyk: "light",
  autumn: "light",
  business: "dark",
  acid: "light",
  lemonade: "light",
  night: "dark",
  coffee: "dark",
  winter: "light",
  dim: "dark",
  nord: "light",
  sunset: "dark",
  caramellatte: "light",
  abyss: "dark",
  silk: "light"
}, P = [
  "floating",
  "fullpage"
], R = [
  "ar",
  "bg",
  "bn",
  "cs",
  "da",
  "de",
  "el",
  "en",
  "en-AU",
  "en-GB",
  "es",
  "et",
  "fi",
  "fr",
  "he",
  "hr",
  "ht",
  "hu",
  "id",
  "is",
  "it",
  "ja",
  "ko",
  "lt",
  "lv",
  "mk",
  "ms",
  "nl",
  "no",
  "pl",
  "pt",
  "ro",
  "ru",
  "sk",
  "sl",
  "sr",
  "sr-CYRL",
  "sv",
  "th",
  "tl",
  "tr",
  "uk",
  "ur",
  "vi",
  "yi",
  "zh",
  "zh-HK",
  "zh-TW"
], H = "auto", k = (e) => e >= "0" && e <= "9", z = (e) => /^[0-9a-fA-F]$/.test(e), i = (e) => e === " " || e === "	" || e === `
`, b = (e) => e >= "a" && e <= "z" || e >= "A" && e <= "Z" || e === "_" || e !== "" && e.charCodeAt(0) >= 128, E = (e) => b(e) || k(e) || e === "-", L = (e) => {
  const n = e.charCodeAt(0);
  return n <= 8 || n === 11 || n >= 14 && n <= 31 || n === 127;
};
function _(e) {
  return e.replace(/\r\n?|\f/g, `
`).replace(/\0/g, "�");
}
function S(e) {
  const n = _(e), c = (l) => n[l] ?? "", r = [];
  let o = 0;
  const a = (l) => c(l) === "\\" && c(l + 1) !== `
`, u = (l) => {
    const t = c(l);
    return t === "-" ? b(c(l + 1)) || c(l + 1) === "-" || a(l + 1) : b(t) ? !0 : t === "\\" && a(l);
  }, m = (l) => {
    const t = c(l);
    return t === "+" || t === "-" ? k(c(l + 1)) || c(l + 1) === "." && k(c(l + 2)) : k(t === "." ? c(l + 1) : t);
  }, f = () => {
    const l = c(o);
    if (l === "") return "�";
    if (!z(l))
      return o++, l;
    let t = "";
    for (; t.length < 6 && z(c(o)); ) t += n[o++];
    i(c(o)) && o++;
    const s = parseInt(t, 16);
    return s === 0 || s > 1114111 || s >= 55296 && s <= 57343 ? "�" : String.fromCodePoint(s);
  }, p = () => {
    let l = "", t = !1;
    for (; ; )
      if (E(c(o))) l += n[o++];
      else if (a(o))
        o++, t = !0, l += f();
      else return { name: l, hadEscape: t };
  }, w = () => {
    for ((c(o) === "+" || c(o) === "-") && o++; k(c(o)); ) o++;
    if (c(o) === "." && k(c(o + 1)))
      for (o++; k(c(o)); ) o++;
    const l = c(o);
    if (l === "e" || l === "E") {
      const t = c(o + 1) === "+" || c(o + 1) === "-" ? 1 : 0;
      if (k(c(o + 1 + t)))
        for (o += 1 + t; k(c(o)); ) o++;
    }
    u(o) ? p() : c(o) === "%" && o++;
  }, g = () => {
    for (; o < n.length && c(o) !== ")"; )
      a(o) ? (o++, f()) : o++;
    c(o) === ")" && o++;
  }, v = (l) => {
    let t = "", s = !1;
    for (; ; ) {
      const h = c(o);
      if (h === ")" || h === "")
        return h === ")" && o++, { type: "url", raw: n.slice(l, o), value: t, hadEscape: s };
      if (i(h)) {
        for (; i(c(o)); ) o++;
        if (c(o) === ")" || c(o) === "") continue;
        return g(), { type: "bad-url", raw: n.slice(l, o) };
      }
      if (h === '"' || h === "'" || h === "(" || L(h))
        return g(), { type: "bad-url", raw: n.slice(l, o) };
      if (h === "\\") {
        if (!a(o))
          return g(), { type: "bad-url", raw: n.slice(l, o) };
        o++, s = !0, t += f();
        continue;
      }
      t += h, o++;
    }
  }, x = (l) => {
    const { name: t } = p(), s = t.toLowerCase();
    if (s === "url" && c(o) === "(") {
      for (o++; i(c(o)) && i(c(o + 1)); ) o++;
      const h = i(c(o)) ? c(o + 1) : c(o);
      if (h === '"' || h === "'")
        return { type: "function", raw: n.slice(l, o), name: s };
      for (; i(c(o)); ) o++;
      return v(l);
    }
    return c(o) === "(" ? (o++, { type: "function", raw: n.slice(l, o), name: s }) : { type: "ident", raw: n.slice(l, o), name: s };
  }, T = (l, t) => {
    o++;
    let s = "", h = !1;
    for (; ; ) {
      const d = c(o);
      if (d === t || d === "")
        return d === t && o++, { type: "string", raw: n.slice(l, o), value: s, hadEscape: h };
      if (d === `
`) return { type: "bad-string", raw: n.slice(l, o) };
      if (d === "\\") {
        c(o + 1) === "" ? o++ : c(o + 1) === `
` ? o += 2 : (o++, h = !0, s += f());
        continue;
      }
      s += d, o++;
    }
  };
  for (; o < n.length; ) {
    const l = o, t = n[o];
    if (t === "/" && c(o + 1) === "*") {
      const s = n.indexOf("*/", o + 2);
      o = s === -1 ? n.length : s + 2, r.push({ type: "comment", raw: n.slice(l, o) });
    } else if (i(t)) {
      for (; i(c(o)); ) o++;
      r.push({ type: "ws", raw: n.slice(l, o) });
    } else if (t === '"' || t === "'")
      r.push(T(l, t));
    else if (t === "#" && (E(c(o + 1)) || a(o + 1)))
      o++, p(), r.push({ type: "hash", raw: n.slice(l, o) });
    else if ("()[]{};:,".includes(t))
      o++, r.push({ type: "punct", raw: t });
    else if ((t === "+" || t === ".") && m(o))
      w(), r.push({ type: "numeric", raw: n.slice(l, o) });
    else if (t === "-")
      m(o) ? (w(), r.push({ type: "numeric", raw: n.slice(l, o) })) : c(o + 1) === "-" && c(o + 2) === ">" ? (o += 3, r.push({ type: "cdc", raw: "-->" })) : u(o) ? r.push(x(l)) : (o++, r.push({ type: "delim", raw: t }));
    else if (t === "<" && n.startsWith("<!--", o))
      o += 4, r.push({ type: "cdo", raw: "<!--" });
    else if (t === "@" && u(o + 1)) {
      o++;
      const { name: s } = p();
      r.push({
        type: "at-keyword",
        raw: n.slice(l, o),
        name: s.toLowerCase()
      });
    } else t === "\\" && a(o) ? r.push(x(l)) : k(t) ? (w(), r.push({ type: "numeric", raw: n.slice(l, o) })) : b(t) ? r.push(x(l)) : (o++, r.push({ type: "delim", raw: t }));
  }
  return r;
}
const C = /* @__PURE__ */ new Set([
  "image-set",
  "-webkit-image-set",
  "src",
  "image",
  "expression"
]), B = /* @__PURE__ */ new Set(["-moz-binding", "behavior"]), U = /* @__PURE__ */ new Set([
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/webp",
  "image/avif",
  "image/svg+xml",
  "font/woff",
  "font/woff2",
  "font/ttf",
  "font/otf"
]);
function y(e, n) {
  const c = e.trim();
  if (/^#[\w-]+$/.test(c)) return c;
  if (/^data:/i.test(c)) {
    const o = c.slice(5).split(/[;,]/)[0].trim().toLowerCase();
    return U.has(o) ? c : null;
  }
  if (n) return null;
  let r;
  try {
    r = new URL(c);
  } catch {
    return null;
  }
  return r.protocol !== "https:" || r.username || r.password ? null : r.href;
}
const A = (e) => `url("${e.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\n/g, "\\a ")}")`;
function N(e) {
  let n = "";
  for (let c = 0; c < e.length; c++) {
    const r = e[c];
    if (r.type === "bad-url" || r.type === "bad-string" || r.type === "at-keyword" && r.name === "import") return null;
    if (r.type === "url") {
      const o = y(r.value, r.hadEscape);
      if (o === null) return null;
      n += A(o);
      continue;
    }
    if (r.type === "function" && C.has(r.name)) return null;
    if (r.type === "function" && r.name === "url") {
      let o = c + 1;
      for (; e[o]?.type === "ws"; ) o++;
      const a = e[o];
      for (o++; e[o]?.type === "ws"; ) o++;
      const u = e[o];
      if (a?.type !== "string" || u?.raw !== ")") return null;
      const m = y(a.value, a.hadEscape);
      if (m === null) return null;
      n += A(m), c = o;
      continue;
    }
    n += r.type === "comment" ? "/**/" : r.raw;
  }
  return n;
}
const O = (e) => e.includes("\\") || e.includes("/*") || e.includes("*/") || [...e].some((n) => n.charCodeAt(0) <= 31 || n.charCodeAt(0) === 127);
function G(e) {
  if (O(e)) return null;
  const n = S(e);
  let c = 0;
  for (const r of n)
    if (r.type === "function" || r.raw === "(" || r.raw === "[") c++;
    else if (r.type === "punct" && (r.raw === ")" || r.raw === "]"))
      c = Math.max(0, c - 1);
    else {
      if (r.type === "punct" && (r.raw === "{" || r.raw === "}"))
        return null;
      if (r.type === "punct" && r.raw === ";" && c === 0) return null;
    }
  return N(n);
}
function $(e) {
  const n = S(e), c = /* @__PURE__ */ new Set();
  return n.forEach((r, o) => {
    if (r.type === "bad-url") c.add(r.raw);
    else if (r.type === "url" && y(r.value, r.hadEscape) === null)
      c.add(r.raw);
    else if (r.type === "function" && r.name === "url") {
      const a = n.slice(o + 1).find((u) => u.type !== "ws");
      (a?.type !== "string" || y(a.value, a.hadEscape) === null) && c.add(`url(${a?.raw ?? ""})`);
    } else r.type === "function" && C.has(r.name) && r.name !== "expression" && c.add(`${r.raw}…)`);
  }), [...c];
}
export {
  H as A,
  B,
  D,
  P as M,
  R as P,
  M as T,
  I as a,
  $ as f,
  N as p,
  y as r,
  G as s,
  S as t
};
//# sourceMappingURL=css-url-policy-BMYkY7Mb.js.map
